var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-market-hype-subscribe',{attrs:{"background-color":_vm.blockColor,"title":_vm.data.title,"lead":_vm.data.lead,"embed-code":_vm.data.embedCode}})}
var staticRenderFns = []

export { render, staticRenderFns }